import type { SearchResult } from '../../../../common/types';

// oxlint-disable-next-line eslint/no-redeclare
const SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;

export interface SearchResultTrelloBoard extends SearchResult {
	__typename: 'SearchResultTrelloBoard';
	lastModifiedDate?: string;
}

export const isSearchResultTrelloBoard = (
	partial: SearchResult,
): partial is SearchResultTrelloBoard => {
	return partial.__typename === 'SearchResultTrelloBoard';
};

// oxlint-disable-next-line eslint/no-redeclare
const SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
}
`;

export interface SearchResultTrelloCard extends SearchResult {
	__typename: 'SearchResultTrelloCard';
	boardName?: string;
	commentsCount?: number;
	lastModifiedDate?: string;
}

export const isSearchResultTrelloCard = (
	partial: SearchResult,
): partial is SearchResultTrelloCard => {
	return partial.__typename === 'SearchResultTrelloCard';
};

export type SearchTrelloPartial = SearchResultTrelloBoard | SearchResultTrelloCard;

export const isSearchTrelloPartial = (partial: SearchResult): partial is SearchTrelloPartial => {
	return isSearchResultTrelloBoard(partial) || isSearchResultTrelloCard(partial);
};

export const getTrelloPartials = () => {
	return `
		${SearchResultTrelloBoard}
		${SearchResultTrelloCard}
	`;
};
